exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".X3TsSESqpMPzdtaHFO1un {\n  color: #fffc;\n  text-align: right;\n  margin-top: 10px;\n}\n\n._3KwegIF4F9GNsg_HlOBfQi {\n  color: #fffe;\n  cursor: pointer;\n  opacity: 0.7;\n}\n._3KwegIF4F9GNsg_HlOBfQi svg {\n  fill: #fff;\n  width: 20px;\n}\n\n._3KwegIF4F9GNsg_HlOBfQi:hover {\n  opacity: 0.9;\n  color: #fff;\n}\n._3KwegIF4F9GNsg_HlOBfQi:active {\n  opacity: 1;\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"Footer": "X3TsSESqpMPzdtaHFO1un",
	"GithubLink": "_3KwegIF4F9GNsg_HlOBfQi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib??ref--1-1!./styles/Footer.css
// module id = 221
// module chunks = 0